import React from "react";
import { cn } from "../../libs/utils";
import { getPlantCompactLabel, getPlantDisplayParts } from "../../services/plantDisplay";

const PlantValue = ({ plant, fallbackPlantId, className }) => {
  const { name, code, id } = getPlantDisplayParts(plant, fallbackPlantId);

  return (
    <div
      className={cn("min-w-0 leading-tight", className)}
      title={getPlantCompactLabel(plant, fallbackPlantId)}
    >
      <div className="truncate text-sm font-semibold text-slate-900">{name}</div>
      {code && (
        <div className="truncate text-xs font-medium text-slate-500">{code}</div>
      )}
      {id && (
        <div className="truncate text-[11px] font-medium text-slate-400">{id}</div>
      )}
    </div>
  );
};

export default PlantValue;
